import React, { useState, useEffect } from 'react';
import { Group, Button, MultiSelect, Box } from '@mantine/core';
import { IconFilterCancel } from '@tabler/icons-react';
import { SiteProvider } from '../../models/siteProvider.ts';

type BillingFilterProps = {
  providers: SiteProvider[];
  tags: string[];
  onFilter: (filters: {
    selectedProviders: SiteProvider[];
    selectedTags: string[];
  }) => void;
};

export default function BillingFilter({
  providers,
  tags,
  onFilter,
}: BillingFilterProps) {
  const [selectedProviders, setSelectedProviders] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);

  useEffect(() => {
    onFilter({ selectedProviders, selectedTags });
  }, [selectedProviders, selectedTags, onFilter]);

  // 清除所有篩選
  const handleClear = () => {
    setSelectedProviders([]);
    setSelectedTags([]);
  };

  return (
    <Box pos="relative">
      <Group>
        <MultiSelect
          label="廠商"
          placeholder="全部"
          data={providers.map((v) => ({ value: v.id, label: v.name }))}
          value={selectedProviders}
          onChange={setSelectedProviders}
          searchable
          clearable
        />
        <MultiSelect
          label="標籤"
          placeholder="全部"
          data={tags.map((tag) => ({ value: tag, label: tag }))}
          value={selectedTags}
          onChange={setSelectedTags}
          searchable
          clearable
        />
      </Group>
      <Box pos="absolute" top={0} right={0}>
        <Button
          variant="outline"
          size="xs"
          onClick={handleClear}
          leftSection={<IconFilterCancel size={14} />}
        >
          清除篩選
        </Button>
      </Box>
    </Box>
  );
}
